module.exports = __webpack_public_path__ + "img/virtual_kit.a9194ec4.png";